import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/reduce";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Promise from "@babel/runtime-corejs3/core-js-stable/promise";
import _regeneratorRuntime from "@babel/runtime-corejs3/regenerator";
import _asyncToGenerator from "@babel/runtime-corejs3/helpers/asyncToGenerator";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _valuesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/values";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context13; _forEachInstanceProperty(_context13 = ownKeys(Object(source), true)).call(_context13, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context14; _forEachInstanceProperty(_context14 = ownKeys(Object(source))).call(_context14, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { createContext, useMemo, useContext, useEffect, useRef, useState } from 'react';
import invariant from 'invariant';
import isEqual from 'react-fast-compare';
import flatten from 'flat';
import { useReducerAsync } from './hooks/use-reducer-async';
import { isPromise } from './utils';
import { get, set, noop, pick, omit, find, map, filter, isFunction, cloneDeep } from 'lodash';
var FormStableContext = /*#__PURE__*/createContext({});
var FormVolatileContext = /*#__PURE__*/createContext({});
var FormStableProvider = FormStableContext.Provider;
var FormVolatileProvider = FormVolatileContext.Provider;
var UPDATE_FIELD = 'UPDATE_FIELD';
var INIT_FIELD_ARRAY = 'INIT_FIELD_ARRAY';
var UPDATE_FIELD_ARRAY = 'UPDATE_FIELD_ARRAY';
var RESET_FIELD_ARRAY = 'RESET_FIELD_ARRAY';
var VALIDATE_FORM = 'VALIDATE_FORM';
var VALIDATE_FIELD = 'VALIDATE_FIELD';
var SET_META = 'SET_META';
var INIT_SUBMIT = 'INIT_SUBMIT';
var INIT_VALIDATION = 'INIT_VALIDATION';
var END_VALIDATION = 'END_VALIDATION';
var END_SUBMIT = 'END_SUBMIT';
var TERMINATE_FIELD = 'TERMINATE_FIELD';
var TERMINATE_FIELD_ARRAY = 'TERMINATE_FIELD_ARRAY';
var SET_FORM_STATE = 'SET_FORM_STATE';
var SUBMIT_FORM = 'SUBMIT_FORM';

function getField(fields, nameOrId) {
  var _fields$nameOrId;

  var field = (_fields$nameOrId = fields === null || fields === void 0 ? void 0 : fields[nameOrId]) !== null && _fields$nameOrId !== void 0 ? _fields$nameOrId : find(fields, function (field) {
    return field.name === nameOrId;
  });
  invariant(field, "Field \"".concat(nameOrId, "\" not found."));
  return field;
}

function getFieldArray(fieldArrays, nameOrId) {
  var _fieldArrays$nameOrId;

  var fieldArray = (_fieldArrays$nameOrId = fieldArrays === null || fieldArrays === void 0 ? void 0 : fieldArrays[nameOrId]) !== null && _fieldArrays$nameOrId !== void 0 ? _fieldArrays$nameOrId : find(fieldArrays, function (fieldArray) {
    return fieldArray.name === nameOrId;
  });
  invariant(fieldArray, "Field Array \"".concat(nameOrId, "\" not found."));
  return fieldArray;
}

function reducer(state, _ref) {
  var type = _ref.type,
      id = _ref.id,
      payload = _ref.payload;

  var fields = state.fields,
      fieldArrays = state.fieldArrays,
      initialValues = state.initialValues,
      values = _valuesInstanceProperty(state),
      touched = state.touched,
      errors = state.errors,
      submitCount = state.submitCount;

  switch (type) {
    case UPDATE_FIELD:
      {
        var _ref2, _ref3;

        var field = payload.field,
            initialValue = payload.initialValue,
            value = payload.value,
            fieldTouched = payload.touched,
            error = payload.error;
        var name = field.name,
            fieldArrayId = field.fieldArrayId;
        return _objectSpread(_objectSpread({}, state), {}, {
          fields: _objectSpread(_objectSpread({}, state.fields), {}, _defineProperty({}, id, field)),
          // Only update initial values if
          // the field is not in a field array
          initialValues: !fieldArrayId ? set(cloneDeep(initialValues), name, isFunction(initialValue) ? initialValue(get(initialValues, name)) : initialValue) : initialValues,
          values: set(cloneDeep(values), name, isFunction(value) ? value(get(values, name)) : value),
          touched: set(cloneDeep(touched), name, (_ref2 = isFunction(fieldTouched) ? fieldTouched(get(touched, name)) : fieldTouched) !== null && _ref2 !== void 0 ? _ref2 : false),
          errors: set(cloneDeep(errors), name, (_ref3 = isFunction(error) ? error(get(errors, name)) : error) !== null && _ref3 !== void 0 ? _ref3 : null)
        });
      }

    case INIT_FIELD_ARRAY:
      {
        var _name = payload.name,
            fieldArrayFields = payload.fields,
            createOrUpdateField = payload.createOrUpdateField;
        return _objectSpread(_objectSpread({}, state), {}, {
          fieldArrays: _objectSpread(_objectSpread({}, fieldArrays), {}, _defineProperty({}, id, {
            id: id,
            name: _name,
            fields: fieldArrayFields,
            createOrUpdateField: createOrUpdateField
          }))
        });
      }

    case UPDATE_FIELD_ARRAY:
      {
        var _ref4;

        var _fields = payload.fields,
            _createOrUpdateField = payload.createOrUpdateField;
        var prevFieldArray = getFieldArray(fieldArrays, id);
        var prevFields = prevFieldArray.fields,
            prevCreateOrUpdateField = prevFieldArray.createOrUpdateField; // We may only be updating the
        // field updater function
        // so default to prevFields here

        var newFields = (_ref4 = isFunction(_fields) ? _fields(prevFields) : _fields) !== null && _ref4 !== void 0 ? _ref4 : prevFields;
        var updater = _createOrUpdateField !== null && _createOrUpdateField !== void 0 ? _createOrUpdateField : prevCreateOrUpdateField;
        return _objectSpread(_objectSpread({}, state), {}, {
          fieldArrays: _objectSpread(_objectSpread({}, fieldArrays), {}, _defineProperty({}, id, _objectSpread(_objectSpread({}, prevFieldArray), {}, {
            createOrUpdateField: updater,
            fields: _mapInstanceProperty(newFields).call(newFields, function (_ref5, index) {
              var field = _ref5.field;
              return updater(field, index);
            })
          })))
        });
      }

    case RESET_FIELD_ARRAY:
      {
        var _newFields = payload.fields,
            _values = _valuesInstanceProperty(payload);

        var _prevFieldArray = getFieldArray(fieldArrays, id);

        var _name2 = _prevFieldArray.name,
            _createOrUpdateField2 = _prevFieldArray.createOrUpdateField;
        return _objectSpread(_objectSpread({}, state), {}, {
          initialValues: _values ? set(cloneDeep(initialValues), _name2, _values) : initialValues,
          fieldArrays: _objectSpread(_objectSpread({}, fieldArrays), {}, _defineProperty({}, id, _objectSpread(_objectSpread({}, _prevFieldArray), {}, {
            fields: _mapInstanceProperty(_newFields).call(_newFields, function (_ref6, index) {
              var field = _ref6.field;
              return _createOrUpdateField2(field, index);
            })
          })))
        });
      }

    case SET_META:
      {
        var meta = payload.meta;
        return _objectSpread(_objectSpread({}, state), {}, {
          meta: meta
        });
      }

    case INIT_SUBMIT:
      return _objectSpread(_objectSpread({}, state), {}, {
        submitCount: submitCount + 1,
        isSubmitting: true
      });

    case INIT_VALIDATION:
      return _objectSpread(_objectSpread({}, state), {}, {
        isValidating: true
      });

    case END_VALIDATION:
      return _objectSpread(_objectSpread({}, state), {}, {
        isValidating: false
      });

    case END_SUBMIT:
      return _objectSpread(_objectSpread({}, state), {}, {
        isSubmitting: false
      });

    case TERMINATE_FIELD:
      {
        var _newFields2 = omit(fields, id);

        var fieldNames = map(_newFields2, function (field) {
          return field.name;
        });

        var _getField = getField(fields, id),
            _fieldArrayId = _getField.fieldArrayId;

        return _objectSpread(_objectSpread({}, state), {}, {
          fields: _newFields2,
          initialValues: !_fieldArrayId ? pick(initialValues, fieldNames) : initialValues,
          values: pick(values, fieldNames),
          touched: pick(touched, fieldNames),
          errors: pick(errors, fieldNames)
        });
      }
    // TODO: Work out if this is what
    // should happen if a field array changes
    // name or is removed from the DOM

    case TERMINATE_FIELD_ARRAY:
      {
        var _getFieldArray = getFieldArray(fieldArrays, id),
            _name3 = _getFieldArray.name;

        return _objectSpread(_objectSpread({}, state), {}, {
          fieldArrays: omit(fieldArrays, id),
          initialValues: omit(initialValues, _name3)
        });
      }

    case SET_FORM_STATE:
      return isFunction(payload) ? payload(state) : payload;

    default:
      return state;
  }
}

var createAsyncActionHandlers = function createAsyncActionHandlers(_ref7) {
  var _ref18;

  var validate = _ref7.validate,
      handleSubmit = _ref7.handleSubmit;
  return _ref18 = {}, _defineProperty(_ref18, VALIDATE_FIELD, function (_ref8) {
    var dispatch = _ref8.dispatch,
        getState = _ref8.getState;
    return /*#__PURE__*/function () {
      var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref9) {
        var id, name, _ref9$payload, value, shouldTouch, payloadField, state, fields, initialValues, values, field, fieldName, setTouched, setError, setIsValidating, validator, isDirty, actions, helpers, error, newError, formErrors, _fieldError, fieldError;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                id = _ref9.id, name = _ref9.name, _ref9$payload = _ref9.payload, value = _ref9$payload.value, shouldTouch = _ref9$payload.shouldTouch, payloadField = _ref9$payload.field;
                state = getState();
                fields = state.fields, initialValues = state.initialValues, values = _valuesInstanceProperty(state);
                field = payloadField || id && (fields === null || fields === void 0 ? void 0 : fields[id]) || name && getField(fields, name);
                fieldName = field.name, setTouched = field.setTouched, setError = field.setError, setIsValidating = field.setIsValidating, validator = field.propValidate;
                _context.prev = 5;
                setIsValidating(true);
                isDirty = getIsDirty(values, initialValues);
                actions = createActions({
                  state: state,
                  dispatch: dispatch
                });
                helpers = _objectSpread(_objectSpread(_objectSpread({}, state), actions), {}, {
                  isDirty: isDirty
                });

                if (shouldTouch) {
                  setTouched(true);
                }

                if (!(validator && isFunction(validator))) {
                  _context.next = 22;
                  break;
                }

                error = validator(value, helpers);

                if (!isPromise(error)) {
                  _context.next = 19;
                  break;
                }

                _context.next = 16;
                return error;

              case 16:
                newError = _context.sent;
                setError(newError);
                return _context.abrupt("return", newError);

              case 19:
                if (!error) {
                  _context.next = 22;
                  break;
                }

                setError(error);
                return _context.abrupt("return", error);

              case 22:
                if (!(validate && isFunction(validate))) {
                  _context.next = 37;
                  break;
                }

                // Validate new value against form
                // level validation, making sure
                // to add other values so we can
                // use cross-field validation when we
                // are validating single fields
                formErrors = validate(set(_objectSpread({}, values), fieldName, value), helpers);

                if (!isPromise(formErrors)) {
                  _context.next = 33;
                  break;
                }

                _context.t0 = get;
                _context.next = 28;
                return formErrors;

              case 28:
                _context.t1 = _context.sent;
                _context.t2 = fieldName;
                _fieldError = (0, _context.t0)(_context.t1, _context.t2);
                setError(_fieldError);
                return _context.abrupt("return", _fieldError);

              case 33:
                fieldError = get(formErrors, fieldName);

                if (!fieldError) {
                  _context.next = 37;
                  break;
                }

                setError(fieldError);
                return _context.abrupt("return", fieldError);

              case 37:
                setError(null);
                return _context.abrupt("return", null);

              case 39:
                _context.prev = 39;
                setIsValidating(false);
                return _context.finish(39);

              case 42:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[5,, 39, 42]]);
      }));

      return function (_x) {
        return _ref10.apply(this, arguments);
      };
    }();
  }), _defineProperty(_ref18, VALIDATE_FORM, function (_ref11) {
    var dispatch = _ref11.dispatch,
        getState = _ref11.getState;
    return /*#__PURE__*/function () {
      var _ref13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref12) {
        var _ref12$payload, shouldTouch, otherValues, state, fields, initialValues, values, _context3, isDirty, actions, setErrors, helpers, validations, formErrors, syncErrors, asyncErrors, asyncValidations, _context5;

        return _regeneratorRuntime.wrap(function _callee4$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _ref12$payload = _ref12.payload, shouldTouch = _ref12$payload.shouldTouch, otherValues = _valuesInstanceProperty(_ref12$payload);
                state = getState();
                fields = state.fields, initialValues = state.initialValues, values = _valuesInstanceProperty(state);
                _context6.prev = 3;
                isDirty = getIsDirty(values, initialValues);
                actions = createActions({
                  state: state,
                  dispatch: dispatch
                });
                setErrors = actions.setErrors;
                helpers = _objectSpread(_objectSpread(_objectSpread({}, state), actions), {}, {
                  isDirty: isDirty
                });
                dispatch({
                  type: INIT_VALIDATION
                });
                validations = [];

                if (validate && isFunction(validate)) {
                  formErrors = validate(otherValues !== null && otherValues !== void 0 ? otherValues : values, helpers);

                  if (isPromise(formErrors)) {
                    validations.push({
                      all: new _Promise( /*#__PURE__*/function () {
                        var _ref14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(resolve) {
                          var errors;
                          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                            while (1) {
                              switch (_context2.prev = _context2.next) {
                                case 0:
                                  _context2.next = 2;
                                  return formErrors;

                                case 2:
                                  errors = _context2.sent;
                                  resolve(errors);

                                case 4:
                                case "end":
                                  return _context2.stop();
                              }
                            }
                          }, _callee2);
                        }));

                        return function (_x3) {
                          return _ref14.apply(this, arguments);
                        };
                      }())
                    });
                  } else {
                    validations.push(formErrors);
                  }
                }

                _forEachInstanceProperty(_context3 = _Object$keys(fields)).call(_context3, function (id) {
                  var _getField2 = getField(fields, id),
                      name = _getField2.name,
                      setTouched = _getField2.setTouched,
                      setIsValidating = _getField2.setIsValidating,
                      validator = _getField2.propValidate;

                  if (shouldTouch) {
                    setTouched(true);
                  }

                  if (validator && isFunction(validator)) {
                    var _get;

                    var error = validator((_get = get(otherValues, name)) !== null && _get !== void 0 ? _get : get(values, name), helpers);

                    if (isPromise(error)) {
                      validations.push(new _Promise( /*#__PURE__*/function () {
                        var _ref15 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(resolve) {
                          var newError;
                          return _regeneratorRuntime.wrap(function _callee3$(_context4) {
                            while (1) {
                              switch (_context4.prev = _context4.next) {
                                case 0:
                                  setIsValidating(true);
                                  _context4.next = 3;
                                  return error;

                                case 3:
                                  newError = _context4.sent;
                                  setIsValidating(false);
                                  resolve(_defineProperty({}, name, newError));

                                case 6:
                                case "end":
                                  return _context4.stop();
                              }
                            }
                          }, _callee3);
                        }));

                        return function (_x4) {
                          return _ref15.apply(this, arguments);
                        };
                      }()));
                    } else {
                      validations.push(_defineProperty({}, name, error));
                    }
                  }
                });

                syncErrors = _reduceInstanceProperty(validations).call(validations, function (acc, val) {
                  if (!isPromise(val)) {
                    return _objectSpread(_objectSpread({}, acc), val);
                  }

                  return acc;
                }, {}); // Overwrite old errors with
                // new synchronous errors

                setErrors(flatten.unflatten(syncErrors));
                asyncErrors = {};
                asyncValidations = _filterInstanceProperty(validations).call(validations, isPromise);

                if (!(asyncValidations.length > 0)) {
                  _context6.next = 23;
                  break;
                }

                _context6.t0 = _reduceInstanceProperty;
                _context6.next = 20;
                return _Promise.all(asyncValidations);

              case 20:
                _context6.t1 = _context5 = _context6.sent;
                asyncErrors = (0, _context6.t0)(_context6.t1).call(_context5, function (acc, val) {
                  return _objectSpread(_objectSpread(_objectSpread({}, asyncValidations === null || asyncValidations === void 0 ? void 0 : asyncValidations.all), acc), val);
                }, {});
                // Overwrite sync errors with
                // async errors but merge old
                // values if async error is
                // null or undefined
                setErrors(flatten.unflatten(asyncErrors), true);

              case 23:
                return _context6.abrupt("return", flatten.unflatten(_objectSpread(_objectSpread({}, syncErrors), asyncErrors)));

              case 24:
                _context6.prev = 24;
                dispatch({
                  type: END_VALIDATION
                });
                return _context6.finish(24);

              case 27:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee4, null, [[3,, 24, 27]]);
      }));

      return function (_x2) {
        return _ref13.apply(this, arguments);
      };
    }();
  }), _defineProperty(_ref18, SUBMIT_FORM, function (_ref16) {
    var dispatch = _ref16.dispatch,
        getState = _ref16.getState;
    return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
      var state, initialValues, values, isSubmitting, isDirty, actions, newErrors, isValid, helpers, submit;
      return _regeneratorRuntime.wrap(function _callee5$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              state = getState();
              initialValues = state.initialValues, values = _valuesInstanceProperty(state), isSubmitting = state.isSubmitting;
              isDirty = getIsDirty(values, initialValues);
              actions = createActions({
                state: state,
                dispatch: dispatch
              });

              if (!isSubmitting) {
                _context7.next = 6;
                break;
              }

              return _context7.abrupt("return", false);

            case 6:
              _context7.prev = 6;
              dispatch({
                type: INIT_SUBMIT
              });
              _context7.next = 10;
              return dispatch({
                type: VALIDATE_FORM,
                payload: {
                  shouldTouch: true
                }
              });

            case 10:
              newErrors = _context7.sent;
              isValid = getIsValid(newErrors);

              if (!isValid) {
                _context7.next = 20;
                break;
              }

              helpers = _objectSpread(_objectSpread(_objectSpread({}, state), actions), {}, {
                isDirty: isDirty
              });
              submit = handleSubmit(values, helpers);

              if (!isPromise(submit)) {
                _context7.next = 19;
                break;
              }

              _context7.next = 18;
              return submit;

            case 18:
              return _context7.abrupt("return", _context7.sent);

            case 19:
              return _context7.abrupt("return", submit);

            case 20:
              return _context7.abrupt("return", false);

            case 21:
              _context7.prev = 21;
              dispatch({
                type: END_SUBMIT
              });
              return _context7.finish(21);

            case 24:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee5, null, [[6,, 21, 24]]);
    }));
  }), _ref18;
};

var initialVals = {};

function getIsDirty(values, initialValues) {
  return !isEqual(values, initialValues);
}

function getIsValid(errors) {
  return filter(flatten(errors), function (error) {
    return error !== null;
  }).length === 0;
}

function createActions(_ref19) {
  var state = _ref19.state,
      dispatch = _ref19.dispatch;
  var fields = state.fields,
      fieldArrays = state.fieldArrays,
      initialValues = state.initialValues;

  var setFieldValue = function setFieldValue(name, value) {
    var merge = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var shouldValidate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

    var _getField3 = getField(fields, name),
        setValue = _getField3.setValue;

    setValue(function (oldValue) {
      var newVal = value;

      if (isFunction(newVal)) {
        newVal = newVal(oldValue);
      }

      if (newVal !== undefined) {
        return newVal;
      }

      if (merge) {
        return oldValue;
      }

      return '';
    }, shouldValidate);
  };

  var setValues = function setValues(values) {
    var _context8;

    var merge = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var shouldValidate = arguments.length > 2 ? arguments[2] : undefined;

    _forEachInstanceProperty(_context8 = _Object$keys(fields)).call(_context8, function (id) {
      var _getField4 = getField(fields, id),
          name = _getField4.name;

      setFieldValue(name, get(values, name), merge, shouldValidate);
    });
  };

  var setFieldTouched = function setFieldTouched(name, touched) {
    var _getField5 = getField(fields, name),
        setTouched = _getField5.setTouched;

    setTouched(function (oldTouched) {
      var newTouched = touched;

      if (isFunction(touched)) {
        newTouched = newTouched(oldTouched);
      }

      if (newTouched !== undefined) {
        return newTouched;
      }

      return oldTouched;
    });
  };

  var setTouched = function setTouched(touched) {
    var _context9;

    _forEachInstanceProperty(_context9 = _Object$keys(fields)).call(_context9, function (id) {
      var _getField6 = getField(fields, id),
          name = _getField6.name;

      setFieldTouched(name, get(touched, name));
    });
  };

  var setFieldError = function setFieldError(name, error, merge) {
    var shouldTouch = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

    var _getField7 = getField(fields, name),
        setError = _getField7.setError;

    setError(function (oldError) {
      var newError = error;

      if (isFunction(newError)) {
        newError = newError(oldError);
      }

      if (newError !== undefined) {
        return newError;
      }

      if (merge) {
        return oldError;
      }

      return null;
    }, shouldTouch);
  };

  var setErrors = function setErrors(errors) {
    var _context10;

    var merge = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    _forEachInstanceProperty(_context10 = _Object$keys(fields)).call(_context10, function (id) {
      var _getField8 = getField(fields, id),
          name = _getField8.name;

      setFieldError(name, get(errors, name), merge);
    });
  };

  var resetField = function resetField(name, value) {
    var shouldValidate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    var _getField9 = getField(fields, name),
        reset = _getField9.reset;

    reset(value !== undefined ? value : get(initialValues, name), shouldValidate);
  };

  var resetFieldArray = function resetFieldArray(nameOrId, values) {
    var _ref20;

    var _getFieldArray2 = getFieldArray(fieldArrays, nameOrId),
        id = _getFieldArray2.id,
        name = _getFieldArray2.name,
        createOrUpdateField = _getFieldArray2.createOrUpdateField;

    var initialFieldValues = (_ref20 = values !== null && values !== void 0 ? values : get(initialValues, name)) !== null && _ref20 !== void 0 ? _ref20 : [];

    var initialFields = _mapInstanceProperty(initialFieldValues).call(initialFieldValues, function (value, index) {
      return createOrUpdateField({
        initialValue: value
      }, index);
    });

    dispatch({
      id: id,
      type: RESET_FIELD_ARRAY,
      payload: {
        values: values,
        fields: initialFields
      }
    });
  };

  var resetForm = function resetForm(newValues) {
    var _context11, _context12;

    var shouldValidate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    _forEachInstanceProperty(_context11 = _Object$keys(fields)).call(_context11, function (id) {
      var _getField10 = getField(fields, id),
          name = _getField10.name,
          inArray = _getField10.inArray,
          reset = _getField10.reset;

      var value = get(newValues, name);

      if (!inArray) {
        reset(value !== undefined ? value : get(initialValues, name), shouldValidate);
      }
    });

    _forEachInstanceProperty(_context12 = _Object$keys(fieldArrays)).call(_context12, function (id) {
      var _getFieldArray3 = getFieldArray(fieldArrays, id),
          name = _getFieldArray3.name;

      resetFieldArray(id, get(newValues, name));
    });
  };

  var setMeta = function setMeta(meta) {
    dispatch({
      type: SET_META,
      payload: {
        meta: meta
      }
    });
  };

  var setFormState = function setFormState(state) {
    dispatch({
      type: SET_FORM_STATE,
      payload: state
    });
  };

  var validateField = function validateField(name) {
    var shouldTouch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    dispatch({
      type: VALIDATE_FIELD,
      payload: {
        name: name,
        shouldTouch: shouldTouch
      }
    });
  };

  var validateForm = function validateForm(values) {
    var shouldTouch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    dispatch({
      type: VALIDATE_FORM,
      payload: {
        values: values,
        shouldTouch: shouldTouch
      }
    });
  };

  var submitForm = function submitForm() {
    return dispatch({
      type: SUBMIT_FORM
    });
  };

  return {
    setValues: setValues,
    setTouched: setTouched,
    setErrors: setErrors,
    setFieldValue: setFieldValue,
    setFieldTouched: setFieldTouched,
    setFieldError: setFieldError,
    resetField: resetField,
    resetFieldArray: resetFieldArray,
    resetForm: resetForm,
    setMeta: setMeta,
    setFormState: setFormState,
    validateField: validateField,
    validateForm: validateForm,
    submitForm: submitForm
  };
}

var cleanProps = function cleanProps(dirtyProps) {
  return omit(dirtyProps, ['dispatch', 'fields', 'fieldArrays', 'safeMode', 'touchOnChange', 'touchOnBlur', 'validateOnChange', 'validateOnBlur', 'shouldUnregister']);
};

function ReactForms(_ref21) {
  var _ref21$safeMode = _ref21.safeMode,
      safeMode = _ref21$safeMode === void 0 ? true : _ref21$safeMode,
      _ref21$touchOnChange = _ref21.touchOnChange,
      touchOnChange = _ref21$touchOnChange === void 0 ? false : _ref21$touchOnChange,
      _ref21$touchOnBlur = _ref21.touchOnBlur,
      touchOnBlur = _ref21$touchOnBlur === void 0 ? true : _ref21$touchOnBlur,
      _ref21$validateOnChan = _ref21.validateOnChange,
      validateOnChange = _ref21$validateOnChan === void 0 ? false : _ref21$validateOnChan,
      _ref21$validateOnBlur = _ref21.validateOnBlur,
      validateOnBlur = _ref21$validateOnBlur === void 0 ? true : _ref21$validateOnBlur,
      _ref21$shouldUnregist = _ref21.shouldUnregister,
      shouldUnregister = _ref21$shouldUnregist === void 0 ? true : _ref21$shouldUnregist,
      _ref21$initialValues = _ref21.initialValues,
      propInitialValues = _ref21$initialValues === void 0 ? initialVals : _ref21$initialValues,
      _ref21$validate = _ref21.validate,
      validate = _ref21$validate === void 0 ? noop : _ref21$validate,
      _ref21$handleSubmit = _ref21.handleSubmit,
      handleSubmit = _ref21$handleSubmit === void 0 ? noop : _ref21$handleSubmit,
      render = _ref21.render,
      children = _ref21.children;
  var asyncActionHandlers = useMemo(function () {
    return createAsyncActionHandlers({
      validate: validate,
      handleSubmit: handleSubmit
    });
  }, [!safeMode && validate, !safeMode && handleSubmit] // eslint-disable-line
  );

  var _useReducerAsync = useReducerAsync(reducer, {
    fields: {},
    fieldArrays: {},
    initialValues: propInitialValues,
    values: propInitialValues,
    touched: {},
    errors: {},
    meta: null,
    submitCount: 0,
    isValidating: false,
    isSubmitting: false
  }, asyncActionHandlers),
      _useReducerAsync2 = _slicedToArray(_useReducerAsync, 2),
      state = _useReducerAsync2[0],
      dispatch = _useReducerAsync2[1];

  var initialValues = state.initialValues,
      values = _valuesInstanceProperty(state),
      errors = state.errors;

  var isDirty = useMemo(function () {
    return getIsDirty(values, initialValues);
  }, [values, initialValues]);
  var isValid = useMemo(function () {
    return getIsValid(errors);
  }, [errors]);
  var actions = useMemo(function () {
    return createActions({
      state: state,
      dispatch: dispatch
    });
  }, [state, dispatch]);
  var helpers = useMemo(function () {
    return _objectSpread(_objectSpread(_objectSpread({}, state), actions), {}, {
      isDirty: isDirty,
      isValid: isValid
    });
  }, [state, actions, isDirty, isValid]);
  var stable = useMemo(function () {
    return {
      safeMode: safeMode,
      initialValues: propInitialValues,
      touchOnChange: touchOnChange,
      touchOnBlur: touchOnBlur,
      validateOnChange: validateOnChange,
      validateOnBlur: validateOnBlur,
      shouldUnregister: shouldUnregister,
      dispatch: dispatch
    };
  }, [safeMode, propInitialValues, touchOnChange, touchOnBlur, validateOnChange, validateOnBlur, shouldUnregister, dispatch]);
  var volatile = useMemo(function () {
    return _objectSpread(_objectSpread(_objectSpread({}, actions), stable), helpers);
  }, [actions, stable, helpers]);
  var props = useMemo(function () {
    return cleanProps(volatile);
  }, [volatile]);
  return /*#__PURE__*/React.createElement(FormStableProvider, {
    value: stable
  }, /*#__PURE__*/React.createElement(FormVolatileProvider, {
    value: volatile
  }, isFunction(children) ? children(props) : isFunction(render) ? render(props) : children));
}

function useReactFormsContext() {
  return useContext(FormVolatileContext);
}

var MemReactForms = /*#__PURE__*/React.memo(ReactForms, isEqual);

function AsyncValuesReadyWrapper(_ref22) {
  var _ref22$asyncValuesRea = _ref22.asyncValuesReady,
      asyncValuesReady = _ref22$asyncValuesRea === void 0 ? true : _ref22$asyncValuesRea,
      props = _objectWithoutProperties(_ref22, ["asyncValuesReady"]);

  var hasReset = useRef(asyncValuesReady);

  var _useState = useState(asyncValuesReady),
      _useState2 = _slicedToArray(_useState, 2),
      valuesReady = _useState2[0],
      setValuesReady = _useState2[1];

  useEffect(function () {
    if (asyncValuesReady && !hasReset.current) {
      setValuesReady(true);
      hasReset.current = true;
    }
  }, [asyncValuesReady]); // eslint-disable-line

  return /*#__PURE__*/React.createElement(MemReactForms, _extends({}, props, {
    key: valuesReady
  }));
}

export { UPDATE_FIELD, INIT_FIELD_ARRAY, UPDATE_FIELD_ARRAY, TERMINATE_FIELD_ARRAY, VALIDATE_FIELD, TERMINATE_FIELD, useReactFormsContext, FormStableContext, FormVolatileContext };
export default AsyncValuesReadyWrapper;